import './bootstrap';

// import Alpine from 'alpinejs';
// window.Alpine = Alpine;
// Alpine.start();

import 'select2/dist/js/select2.full';
import 'select2/dist/js/i18n/cs.js'
import I18n from './vendor/I18n';
window.I18n = I18n;

require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/widgets/sortable');
require('jquery-ui/ui/widgets/autocomplete');
// require('chosen-js/chosen.jquery.min');
require('./chosen-js/chosen.jquery.js');
require('lightslider/dist/js/lightslider.min.js');
require('simplelightbox/dist/simple-lightbox.jquery.js');
require('lazyload/lazyload.min.js');
require('./functions');
require('./functions/list');
require('./functions/modal');
require('./user/update');
require('./cron/index');
require('./translated-product/index');
require('./feed-mapping/edit-step-3');
require('./functions/render-row');
require('./functions/activity-progress-bar');
require('./to-translate/index');
require('./connection/import');
require('./product/show');
require('./rule/edit');
require('./shopify/login');
require('./aire-validator');
require('./main');
require('./dashboard/charts');
import LivewireButtonLoaders from "./livewireButtonLoaders";
import Cookies from 'js-cookie';

import GraphPopup from './homepage/graphPopup';
import ProductChecked from './product-checked/ProductChecked';
import AlertModal from './functions/AlertModal';
import Timer from './functions/timer';
import Chat from './vendor/loco-chat/widget.mjs';

window.app = window.app || {};
window.app.graphPopup = new GraphPopup();
window.app.productChecked = new ProductChecked();
window.app.alertModal = new AlertModal();
window.app.timer = new Timer();
window.app.livewireButtonLoaders = new LivewireButtonLoaders;
window.app.locoChat = Chat;
window.app.cookies = Cookies;
